var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../.././store';
import { Store } from '@ngrx/store';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
var INDRAWeakFlightsDiscountModalComponent = /** @class */ (function (_super) {
    __extends(INDRAWeakFlightsDiscountModalComponent, _super);
    function INDRAWeakFlightsDiscountModalComponent(modalService, store, bookingSearchService) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.store = store;
        _this.bookingSearchService = bookingSearchService;
        _this.searchRoute$ = _this.store.select(fromStore.getMiniIBESearchRoutes);
        _this.amountValue$ = _this.store.select(fromStore.getWeakFlightAmt);
        _this.isAlive = true;
        _this.searchRoute$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (searchRoute) {
            _this.searchRoute = searchRoute;
        });
        return _this;
    }
    INDRAWeakFlightsDiscountModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        var weakFLightReq = {
            'origin': this.searchRoute[0].departure.code,
            'destination': this.searchRoute[0].arrival.code,
            'fareBasis': ['WEAK'],
            'fareFamily': ['WEAK']
        };
        this.weakFlightsSubscription = this.bookingSearchService.INDRA_getInformationWeakFlights(weakFLightReq).subscribe(function (res) {
            if (res && res.status === '200' && res.amount) {
                _this.amountValue = {
                    'amount': res.amount,
                    'currency': res.currency
                };
                _this.store.dispatch(new BookedTripActions.PutWeakFlightAmount(_this.amountValue));
            }
        });
    };
    INDRAWeakFlightsDiscountModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        this.weakFlightsSubscription.unsubscribe();
    };
    INDRAWeakFlightsDiscountModalComponent.prototype.INDRA_close = function () {
        this.closeModal();
    };
    return INDRAWeakFlightsDiscountModalComponent;
}(AbstractModalContentComponent));
export { INDRAWeakFlightsDiscountModalComponent };
